export const CUSTOM = 'custom';
export const FEATURED = 'featured';
export const FREE = 'free';
export const PAID = 'paid';
export const ALL = 'all';
export const H2H = 'h2h';
